import Securities from './Securities';

export default Securities;



// WEBPACK FOOTER //
// ./src/views/securities/index.js